/*
 * PDP accordions — slide open and closed.
 *
 * <details> toggles instantly, and there is no CSS-only way to animate it
 * shut: the browser stops rendering the body the moment `open` is removed, so
 * a transition has nothing left to run against. The close therefore has to be
 * animated first and `open` removed on finish.
 *
 * The element being animated is the <details> itself, from the height of its
 * <summary> to its full height, rather than the body inside it. Animating the
 * body would mean animating its padding alongside its height — with
 * box-sizing: border-box a height of 0 still leaves the padding standing, so
 * the panel would jump the last 20px. Sizing the outer element sidesteps that
 * entirely and keeps the summary put throughout.
 *
 * Bound once, by delegation on the document, so accordions that arrive later
 * work without rebinding. That matters on the product page, where switching
 * material swaps the whole section — including this script, which re-runs and
 * returns at the guard below.
 */
(function () {
  if (window.__pdpAccordionBound) return;
  window.__pdpAccordionBound = true;

  /* Matches the caret's own transform transition in component-pdp.css. */
  var DURATION = 250;
  var EASING = 'ease';

  function prefersReducedMotion() {
    return (
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  function settle(details) {
    details.style.overflow = '';
    details.style.height = '';
    details.classList.remove('is-collapsing');
    details.__pdpAnim = null;
    details.__pdpClosing = false;
  }

  document.addEventListener('click', function (event) {
    var summary = event.target.closest && event.target.closest('.pdp-accordion summary');
    if (!summary) return;

    var details = summary.parentElement;
    if (!details || details.tagName !== 'DETAILS') return;

    /* Leave the native toggle alone where motion is unwelcome, or where the
       Web Animations API is not there to drive it. */
    if (prefersReducedMotion() || typeof details.animate !== 'function') return;

    event.preventDefault();

    /* Where it is right now, taken before anything is cancelled or cleared:
       mid-animation this is the height the animation had reached. */
    var from = details.getBoundingClientRect().height;

    /* A panel sliding shut is still `open`, so reading the attribute would
       start closing it a second time instead of reversing. Track the
       intention separately. */
    var reversingAClose = details.__pdpClosing === true;
    if (details.__pdpAnim) details.__pdpAnim.cancel();

    /* The cancelled run left an inline height behind; clear it so the natural
       height can be measured. */
    details.style.height = '';
    details.style.overflow = '';

    var closing = reversingAClose ? false : details.open;
    details.__pdpClosing = closing;
    /* Turns the caret now rather than when the panel has finished closing. */
    details.classList.toggle('is-collapsing', closing);

    var to;
    if (closing) {
      to = summary.getBoundingClientRect().height;
    } else {
      /* Open it to measure, then animate from where it was. No frame is
         painted in between — the animation starts in the same task. */
      details.open = true;
      to = details.getBoundingClientRect().height;
    }

    details.style.overflow = 'hidden';
    details.style.height = from + 'px';

    var anim = details.animate(
      { height: [from + 'px', to + 'px'] },
      { duration: DURATION, easing: EASING }
    );
    details.__pdpAnim = anim;

    anim.onfinish = function () {
      /* Tracked as a flag rather than inferred from the measurements: a panel
         whose open height happens to equal its summary's would otherwise be
         read as closing and snap shut. */
      if (closing) details.open = false;
      settle(details);
    };
    /* cancel() fires this too; the reversing click has already set up its own
       state, so this must not clear it. */
    anim.oncancel = function () {
      if (details.__pdpAnim === anim) details.__pdpAnim = null;
    };
  });
})();
